module.exports = __webpack_public_path__ + "static/vaccination1920_952-d2c4165141feb2da14c8d611279da74f.png";